
































































































































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { notificationService } from '@/services/notification-service';
import { InboxNotification } from '@/models/inbox-notification';
import NotificationsSidebar from '@/components/display/notifications-sidebar.vue';
import SearchBar from '@/pages/search/components/search-bar.vue';

@Component({
	components: {
		SearchBar,
		NotificationsSidebar,
	},
})
export default class Navigation extends Vue {
	public inboxNotifications: InboxNotification[] = [];
	public smallScreen = window.innerWidth;
	public showSearch: boolean = this.smallScreen >= 1200;

	public appVersion: string = process.env.VUE_APP_UI_VERSION;

	public bgEnvClass() {
		const host = window.location.host;
		if (host.indexOf('uat') > -1) {
			return 'uat';
		} else if (host.indexOf('local') > -1) {
			return 'local';
		} else {
			return '';
		}
	}

	public created() {
		notificationService.notifications.subscribe((notifications: InboxNotification[]) => {
			this.inboxNotifications = notifications;
		});
		window.addEventListener('resize', this.myEventHandler);
		this.onScreenSizeChanged();
	}

	public async logout() {
		localStorage.removeItem('user-token');
		this.$auth.logout({ makeRequest: true }); // logout function redirects to /auth/login
	}

	@Watch('smallScreen')
	public onScreenSizeChanged() {
		this.showSearch = this.smallScreen >= 1200;
	}

	public destroyed() {
		window.removeEventListener('resize', this.myEventHandler);
	}

	public myEventHandler(e) {
		this.smallScreen = e.target.innerWidth;
	}
}
